import { useCallback, useState } from 'react';
import { homeAPI } from 'src/api/home-api';
import { HTBaiViet } from 'src/types/htblog';
import { IErrorType } from 'src/types/error';

type StatusProps = { loading: boolean; empty?: boolean; error: IErrorType };

export default function useHome() {
  const [homeBlogs, setHomeBlogs] = useState<HTBaiViet[]>([]);
  const [homeBlogsStatus, setHomeBlogsStatus] = useState<StatusProps>({ loading: false, empty: false, error: null });

  const setStatus = useCallback((name: keyof StatusProps, value: any) => {
    setHomeBlogsStatus((prev) => ({ ...prev, [name]: value }));
  }, []);

  const getHomeBlogs = useCallback(async () => {
    setStatus('loading', true); 
    setStatus('error', null);
    try {
      const params = {
          searchBy: ["TheLoaiId NotEquals '1003'", "TheLoaiId NotEquals '1002'"],
          Status: 1
        };
      const resp = await homeAPI.listHomeBaiViet(params);
      const items = resp?.items ?? [];
      setHomeBlogs(items);
      setStatus('empty', items.length === 0); 
    } catch (error) {
      console.error('Error fetching home blogs:', error);
      setStatus('error', error as any);
      setHomeBlogs([]);
    } finally {
      setStatus('loading', false);
    }
  }, [setStatus]);

  const [faqs, setFaqs] = useState<HTBaiViet[]>([]);
  const [faqStatus, setFaqStatus] = useState<StatusProps>({ loading: false, empty: false, error: null });

  const setFaqStatusCallback = useCallback((name: keyof StatusProps, value: any) => {
    setFaqStatus((prev) => ({ ...prev, [name]: value }));
  }, []);

  const getFAQs = useCallback(async () => {
    setFaqStatusCallback('loading', true);
    setFaqStatusCallback('error', null);
    try {
      const params = {
        searchBy: ["TheLoaiId Equals '1003'"], 
        Status: 1,
      };
      
      const resp = await homeAPI.listHomeBaiViet(params);
      const items = resp?.items ?? [];
      setFaqs(items);
      setFaqStatusCallback('empty', items.length === 0);
    } catch (error) {
      console.error('Error fetching FAQs:', error);
      setFaqStatusCallback('error', error as any);
      setFaqs([]);
    } finally {
      setFaqStatusCallback('loading', false);
    }
  }, [setFaqStatusCallback]);

  return { 
    // Home Blogs
    homeBlogs, 
    homeBlogsStatus, 
    getHomeBlogs,
    // FAQs
    faqs,
    faqStatus,
    getFAQs
  };
}